import { Document } from "@/models/socio-model";
// INFO - NL - 13/04/2023 - This class doesn't inherit from socio-vue-component document model as
// it is based on custom document model
export default class QuestionnaireDocument extends Document {
  static entity = "questionnaireDocuments";

  static fields() {
    return {
      ...super.fields(),
      // Questionnaire document fields
      // uuid of questionnaire document
      documentUuid: this.attr(null),

      // Document additional fields
      file: this.attr(null),
      datetimeFormat: this.attr(null),
      createdBy: this.attr(null),
      modifiedBy: this.attr(null),
      documentCustom: this.attr(null),
      filename: this.attr(null),
      isDisplayed: this.boolean(false),
      questions: this.attr([]),
      documentName: this.attr(null),
    };
  }
}
